import {
    DEFAULT_STATUS_THEME,
    STATUS_THEME_CSS_VARS,
    type StatusThemeTokens,
} from './theme.status.defaults';
import { DEFAULT_THEME_TOKENS } from './theme.defaults';
import { THEME_CSS_VARS, type ThemeTokens } from './theme.tokens';

export type FullThemeTokens = ThemeTokens & StatusThemeTokens;

export const DEFAULT_FULL_THEME: FullThemeTokens = {
    ...DEFAULT_THEME_TOKENS,
    ...DEFAULT_STATUS_THEME,
};

export const FULL_THEME_CSS_VARS: Record<keyof FullThemeTokens, string> = {
    ...THEME_CSS_VARS,
    ...STATUS_THEME_CSS_VARS,
};
